var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabValues(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.628,7.422l-0.826,0.825L8.288,5.733 l2.391-2.392c0.379-0.379,1.002-0.379,1.381,0l1.134,1.134c0.344,0.343,0.377,0.883,0.1,1.264l-0.11,0.121"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.139,4.414l0.966-0.967 c0.154-0.153,0.154-0.405,0-0.558L13.646,2.43c-0.153-0.153-0.404-0.153-0.558,0l-0.967,0.967L13.139,4.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8,7.519L7.032,8.486 c-0.153,0.153-0.153,0.405,0,0.559l0.459,0.458c0.153,0.154,0.404,0.154,0.559,0l0.967-0.967L8,7.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.796,6.265 C7.569,6.64,7.616,7.138,7.939,7.462l1.134,1.134c0.324,0.323,0.822,0.37,1.197,0.144L7.796,6.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.997,8.95 c-0.143,0.142-0.373,0.139-0.518-0.005L7.591,6.056C7.446,5.912,7.443,5.68,7.585,5.539l0,0C7.726,5.397,7.958,5.4,8.102,5.544 l2.89,2.889C11.136,8.578,11.138,8.809,10.997,8.95L10.997,8.95z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 12.313,
    cy: 6.542,
    r: 1.111
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 12.306,
    cy: 6.549,
    r: 0.607
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.059,15.037 c-1.495-0.311-2.739-1.306-3.39-2.643"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.403,6.723 c0.939,0.888,1.525,2.146,1.525,3.542c0,2.345-1.657,4.303-3.863,4.769"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.073,13.959 c-0.9-0.235-1.667-0.802-2.162-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12.496,7.635 c0.747,0.677,1.217,1.655,1.217,2.743c0,1.696-1.14,3.124-2.694,3.563"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 10.051,
    cy: 14.492,
    r: 1.124
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 10.051,
    cy: 14.492,
    r: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.576,11.948H5.071v0.464h3.505 c0.128,0,0.231-0.104,0.231-0.231C8.808,12.053,8.704,11.948,8.576,11.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.933,17.005 c0,0.376-0.304,0.681-0.681,0.681H6.668c-0.376,0-0.681-0.305-0.681-0.681v-0.241c0-0.377,0.305-0.682,0.681-0.682h6.584 c0.377,0,0.681,0.305,0.681,0.682V17.005z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "8.317,14.819 8.317,16.075  11.603,16.075 11.603,14.89  "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 9.04,
    y1: 5.809,
    x2: 10.983,
    y2: 3.922
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabValues);
export default __webpack_public_path__ + "static/media/lab_values.b65c9faf3a031beed9d855d0b3d36a6e.svg";
export { ForwardRef as ReactComponent };